const colors = {
  primaryColor: "#2F3C7E",
  pastelPink: "#FBEAEB",
  whiteColor: "#FFFFFF",
  blackColor: "black",
  stoneGrayColor: "#595656",
  darkGray: "#3A3A3A",
  lighterGray: "#5D5D5D",
  lighterBorder: "#E5D5E5",
  lighterGrayBorder: "#DFDFDF",
  darkBorder: "#263238",
  charcoalBorder: "#37474F",
  primaryBtnColor: "#2F3C7E",
  secondaryBtnColor: "#3F4E8C",
  softGreen: "#C8E6C9",
  paleRed: "#FFCDD2",
  successText: "#388E3C",
  errorText: "#D32F2F",
  success: "#22bb33",
  warning: "#fff600",
  error: "red",
  messageBgColor: "#FFE0FA",
  backgroundColor:
    "radial-gradient(rgb(210, 241, 223),rgb(211, 215, 250),rgb(186, 216, 244))0% 0%/400% 400%",
};
export default colors;
